import { Field } from '#app/components/form/field.tsx'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type Props = {
	readonly resources: SectionResources
	readonly complianceContactEmail: string
	readonly errors: readonly string[]
	readonly onChange: (value: string) => void
}

export function EscalationSection({
	resources,
	complianceContactEmail,
	errors,
	onChange,
}: Props) {
	return (
		<Section
			title="Escalation inbox"
			description="List the monitored inbox auditors should use when they need answers fast."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
		>
			<Field
				labelProps={{
					children: 'Which inbox should we use for compliance escalations?',
				}}
				inputProps={{
					name: 'complianceContactEmail',
					value: complianceContactEmail,
					onChange: (event) => onChange(event.target.value),
					type: 'email',
					autoComplete: 'email',
				}}
				descriptionProps={{
					children:
						'We’ll surface this for recall drills, adverse events, and record-access requests.',
				}}
				errors={errors.length > 0 ? [...errors] : undefined}
			/>
		</Section>
	)
}
